<template>
  <div class="trivia-container">
    <div class="timer"><h3>:20</h3></div>
    <Title :title="this.$store.state.currentCategory" />
    <router-link to="/trivia/questions">
      <Button color="orange" buttonText="Start" class="button"></Button>
    </router-link>
  </div>
</template>

<script>
import Button from '@/components/Button.vue'
import Title from '@/components/Title.vue'

export default {
  name: 'triviaCategory',
  components: {
    Button,
    Title
  },
  mounted() {
    this.$ga.page('/trivia/category')
  }
}
</script>

<style scoped>
  .trivia {
    left: 50%;
    position: absolute;
    top: 300px;
    transform: translateX(-50%);
  }

  .trivia-container {
    height: 100vh;
    position: relative;
  }

  .trivia-img {
    position: absolute;
    right: -100px;
    top: 100px;
  }

  .title {
    top: 350px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    clip-path: polygon(3% 0, 100% 0, 97% 100%, 0 100%);
    padding: 35px 65px;
    font-size: 80px;
    font-weight: bold;
    width: 100%;
    max-width: 750px;
  }

  .button {
    top: 675px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .orange {
    color: #fdba07;
  }

  p {
    color: #fff;
    font-size: 32px;
    text-align: left;
    max-width: 605px;
    margin: 35px 0;
  }

  .bold {
    font-size: 36px;
    font-weight: bold;
  }

  .timer {
    background: url('../assets/timer_bg.png') top center no-repeat;
    height: 210px;
    position: absolute;
    left: 50%;
    margin-bottom: 50px;
    top: -7px;
    transform: translateX(-50%);
    width:279px;
  }

  h3 {
    bottom:40px;
    color: #fff;
    font-size: 62px;
    font-weight: 900;
    left: 50%;
    margin: 0;
    position: absolute;
    transform: translateX(-50%);
  }
</style>